export const LOCALSTORAGE_TOKEN = 'b2b_token';
